// extracted by mini-css-extract-plugin
export default {"tooltip":"Mn-z","sharingV2":"Nn-z","sharingIconsV2":"On-z","links":"Pn-z","link":"Qn-z","facebookV2":"Rn-z","twitterV2":"Sn-z","pinterestV2":"Tn-z"};